module.exports = __webpack_public_path__ + "static/media/ESSEL.17c84d93.svg";